<template>
  <div class="flex justify-center">
    <TabLink :route="'workspace-members'">
      {{ isLoadingMembers ? '' : members.length }} Members
    </TabLink>
    <TabLink route="workspace-external-users"
      >{{ isLoadingExternalUsers ? '' : Object.keys(externalUsers).length }}
      Guests
    </TabLink>
    <Protect :permissions="[SYS_PERMISSIONS.SYS_MEMBERSHIPS_MANAGE]">
      <TabLink :route="'workspace-invitations'">
        {{ isLoadingInvitations ? '' : invitations.length }} Invitations
      </TabLink>
    </Protect>
  </div>
</template>

<script setup>
import Protect from '@/hoc/Protect.vue';
import { TabLink } from '@ui/components/tabs';
import { SYS_PERMISSIONS } from '@/constants.js';
import { useQuery } from '@tanstack/vue-query';
import { queries } from '@/queries/index.js';

const { isLoading: isLoadingMembers, data: members } = useQuery(
  queries.workspace.members
);

const { isLoading: isLoadingExternalUsers, data: externalUsers } = useQuery(
  queries.workspace.externalUsers
);

const { isLoading: isLoadingInvitations, data: invitations } = useQuery(
  queries.workspace.invitations({ status: ['PENDING'] })
);
</script>
